import Cookies from 'js-cookie';

export function removeToken() {
  const tokenNames = [
    'apiToken', 'token', 'user_ticket',
    'rememberToken', 'rememberToken',
    'auth_token', 'auth_code', 'clientId'
  ];
  const currentDomain = window.location.hostname;

  tokenNames.forEach((name) => {
    // 删除当前域名下的 cookie（指定 domain 和 path）
    Cookies.remove(name, { path: '/', domain: currentDomain });
    // 尝试删除根域名下的 cookie
    Cookies.remove(name, { path: '/', domain: '.linkdoc.com' });
    // 兜底：不带参数删除
    Cookies.remove(name);
  });
}
